class RecentlyViewedProducts extends HTMLElement {
  connectedCallback() {
    this.grid = this.querySelector('[data-recently-viewed-grid]');
    this.cardSectionId = this.dataset.cardSectionId;
    this.currentHandle = this.dataset.currentHandle;
    this.max = parseInt(this.dataset.max, 10) || 4;
    if (this.grid) this.init();
  }

  getStoredHandles() {
    try {
      return JSON.parse(window.localStorage.getItem('luvenza:recently-viewed') || '[]');
    } catch (error) {
      return [];
    }
  }

  async fetchCard(handle) {
    try {
      const response = await fetch('/products/' + handle + '?section_id=' + this.cardSectionId);
      if (!response.ok) return null;
      const text = await response.text();
      const doc = new DOMParser().parseFromString(text, 'text/html');
      const card = doc.querySelector('.card-wrapper');
      return card ? card.outerHTML : null;
    } catch (error) {
      return null;
    }
  }

  async init() {
    const handles = this.getStoredHandles()
      .filter((handle) => handle !== this.currentHandle)
      .slice(0, this.max);

    if (handles.length === 0) return;

    const cards = await Promise.all(handles.map((handle) => this.fetchCard(handle)));
    const validCards = cards.filter(Boolean);

    if (validCards.length === 0) return;

    validCards.forEach((html) => {
      const item = document.createElement('li');
      item.className = 'grid__item';
      item.innerHTML = html;
      this.grid.appendChild(item);
    });

    this.hidden = false;
  }
}

customElements.define('recently-viewed-products', RecentlyViewedProducts);
